/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReviewDecision } from './ReviewDecision';
import {
    ReviewDecisionFromJSON,
    ReviewDecisionFromJSONTyped,
    ReviewDecisionToJSON,
    ReviewDecisionToJSONTyped,
} from './ReviewDecision';

/**
 * A reviewer's verdict; `None` clears an earlier one.
 * @export
 * @interface ReviewDecisionUpdate
 */
export interface ReviewDecisionUpdate {
    /**
     * 
     * @type {ReviewDecision}
     * @memberof ReviewDecisionUpdate
     */
    decision?: ReviewDecision | null;
}



/**
 * Check if a given object implements the ReviewDecisionUpdate interface.
 */
export function instanceOfReviewDecisionUpdate(value: object): value is ReviewDecisionUpdate {
    return true;
}

export function ReviewDecisionUpdateFromJSON(json: any): ReviewDecisionUpdate {
    return ReviewDecisionUpdateFromJSONTyped(json, false);
}

export function ReviewDecisionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewDecisionUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'decision': json['decision'] == null ? undefined : ReviewDecisionFromJSON(json['decision']),
    };
}

export function ReviewDecisionUpdateToJSON(json: any): ReviewDecisionUpdate {
    return ReviewDecisionUpdateToJSONTyped(json, false);
}

export function ReviewDecisionUpdateToJSONTyped(value?: ReviewDecisionUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'decision': ReviewDecisionToJSON(value['decision']),
    };
}

